import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-004a8e65")

_pushScopeId("data-v-004a8e65")
const _hoisted_1 = { class: "font-montserrat download-csv" }
const _hoisted_2 = { class: "\n        justify-end\n        items-center\n        flex\n        overflow-hidden\n        fixed\n        inset-0\n        z-40\n        outline-none\n        focus:outline-none\n      " }
const _hoisted_3 = { class: "relative w-5/12 h-screen flex flex-col justify-between bg-white" }
const _hoisted_4 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_5 = { class: "px-8 inline-flex justify-between w-full" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4" }, "Download Transaksi", -1)
const _hoisted_7 = { class: "px-8 py-4 overflow-auto h-screen pb-10" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-montserrat font-normal opacity-50" }, " Isi kolom dibawah dengan benar dan sesuai untuk pengunduhan data transaksi. ", -1)
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = { class: "flex flex-col my-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }, " Tipe Transaksi ", -1)
const _hoisted_12 = { class: "flex flex-col my-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }, " Tipe Akun ", -1)
const _hoisted_14 = { class: "flex flex-col my-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }, " Nama Client/Partner ", -1)
const _hoisted_16 = { class: "flex flex-col my-4" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }, " Dibuat oleh ", -1)
const _hoisted_18 = { class: "flex flex-col my-4" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }, " Tanggal Transaksi ", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-30 bg-black" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("img", {
                  src: _imports_0,
                  class: "w-4 cursor-pointer",
                  alt: "close",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
                })
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_Select, {
                    dataSelect: _ctx.transactionTypeData,
                    onOpenSelect: _ctx.onOpenTransactionTypeSelect,
                    onCloseSelect: _ctx.onCloseTransactionTypeSelect,
                    onChooseSelect: _ctx.onSelectTransactionType,
                    value: _ctx.transactionTypeName,
                    isOpenMenu: _ctx.transactionTypeSelect,
                    isDefaultBlack: "",
                    class: "text-12px xxl:text-14px my-2 z-20",
                    style: {"width":"22rem"},
                    longTrim: 30
                  }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                ]),
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_Select, {
                    dataSelect: _ctx.typeData,
                    onOpenSelect: _ctx.onOpenTypeSelect,
                    onCloseSelect: _ctx.onCloseTypeSelect,
                    onChooseSelect: _ctx.onSelectType,
                    value: _ctx.typeName,
                    isOpenMenu: _ctx.typeSelect,
                    class: "text-12px xxl:text-14px my-2",
                    style: {"width":"22rem"},
                    longTrim: 30,
                    isDisabled: _ctx.isAccountTypeDisabled
                  }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu", "isDisabled"])
                ]),
                _createVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_SelectSearch, {
                    isDisabled: !_ctx.typeName,
                    placeholder: "Pilih client/partner",
                    modelValue: _ctx.clientNameDisplay,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.clientNameDisplay = $event)),
                    options: _ctx.clientNameList,
                    onFilter: _ctx.onSearchClientName,
                    keyName: "name",
                    keyValue: "id",
                    isLoading: _ctx.isLoadingPartnerClient,
                    class: "my-2",
                    style: {"width":"22rem"}
                  }, null, 8, ["isDisabled", "modelValue", "options", "onFilter", "isLoading"])
                ]),
                _createVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_SelectSearch, {
                    placeholder: "Pilih",
                    modelValue: _ctx.createdByName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.createdByName = $event)),
                    options: _ctx.listActor,
                    onFilter: _ctx.fetchActors,
                    keyName: "createdName",
                    keyValue: "createdId",
                    isLoading: _ctx.isLoadingActors,
                    class: "my-2",
                    style: {"width":"22rem"}
                  }, null, 8, ["modelValue", "options", "onFilter", "isLoading"])
                ]),
                _createVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_time_range_picker, {
                    default: "7 hari terakhir",
                    class: "mr-4 my-2",
                    startDate: _ctx.startDate,
                    endDate: _ctx.endDate,
                    onSelect: _ctx.setDateRange,
                    style: {"margin-right":"0","width":"22rem"},
                    minDate: _ctx.minDate,
                    maxDate: _ctx.maxDate,
                    onDayClick: _ctx.setDay,
                    onCancelRangePick: _ctx.cancelRangePick,
                    showOptions: "custom, hari ini, 7 hari terakhir, 30 hari terakhir",
                    isOptionDisabled: !_ctx.isStartDate
                  }, null, 8, ["startDate", "endDate", "onSelect", "minDate", "maxDate", "onDayClick", "onCancelRangePick", "isOptionDisabled"])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", {
          class: "\n          w-5/12\n          z-20\n          absolute\n          bottom-0\n          items-center\n          flex flex-row\n          rounded-b-md\n          text-xs\n          bg-gray-lp-700\n          justify-end\n          px-8\n          py-4\n        ",
          style: `${_ctx.isShowRunningText ? 'bottom: 16px;' : ''}`
        }, [
          _createVNode(_component_button_outline, {
            custom: "bg-white px-12 border border-red-lp-500 text-red-lp-500 mr-4",
            title: "Batal",
            onClick: _ctx.onClose
          }, null, 8, ["onClick"]),
          _createVNode(_component_button_fill, {
            custom: "px-12 bg-red-lp-200",
            title: "Download",
            onClick: _ctx.onDownloadReport,
            isDisabled: _ctx.isDisabled
          }, null, 8, ["onClick", "isDisabled"])
        ], 4)
      ]),
      _hoisted_20
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseModalSuccess,
      title: "Perubahan Disimpan",
      message: `Pengunduhan Berhasil`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit"]), [
      [_vShow, _ctx.openModalSuccess]
    ])
  ], 64))
})